export default __webpack_public_path__ + "static/media/fast-delivery.d5c28cd5.png";